// extracted by mini-css-extract-plugin
export default {"detailsDisclaimer":"_97293c2d"};